/* eslint-disable import/prefer-default-export */
import config from 'lib/cloud-sync/cloud-api/config'
import { CloudAPI } from 'lib/cloud-sync/cloud-api/types.d'
import { cloudApiFetch, handleError } from 'lib/cloud-sync/cloud-api/api-fetch'

/**
 * Get user's account info.
 * @param token Access token
 */
export const getAccountInfo = async (
  token: string,
): Promise<CloudAPI.UserAccountResponse> => {
  const { API_USE_MOCKS } = config
  if (API_USE_MOCKS) {
    throw new Error('Cannot load account info in mock mode')
  }
  const result = await cloudApiFetch({
    method: 'GET',
    path: '/whoami/',
    token,
  })

  if (!result.ok) {
    return handleError(result)
  }

  const responseBody = await result.body.json()
  return responseBody as CloudAPI.UserAccountResponse
}
